import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Stack,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import StyledButton from '../../common/StyledButton';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const PendingApproval = ({ onBack, vendorData }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const submitForApproval = async () => {
      try {
        const response = await fetch('/api/vendor/submit-for-approval', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.token}`,
          }
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.error ||
              "We couldn't submit your registration. Confirm you have at least one booth selected, then click Submit again."
          );
        }

        const result = await response.json();
        console.log('Registration submitted for approval:', result);
      } catch (error) {
        console.error('Error submitting registration for approval:', error);
      }
    };

    submitForApproval();
  }, [user]);

  const handleViewDashboard = () => {
    navigate('/vendor/dashboard');
  };

  return (
    <Paper elevation={3} sx={{ p: 4, mt: 2 }}>
      <Stack spacing={3} alignItems="center">
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64 }} />
          <Typography variant="h4" gutterBottom>
            Registration Complete!
          </Typography>
        </Box>

        <Alert severity="info" sx={{ width: '100%' }}>
          Your vendor registration is now pending approval from our administrators.
          You will receive an email notification once your application has been
          reviewed.
        </Alert>

        <Typography variant="body1" textAlign="center">
          Thank you for registering as a vendor for The Gingham Tree Market! Our
          team will review your application and get back to you within 2-3 business
          days.
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            What happens next?
          </Typography>
          <Typography variant="body2" component="ul" sx={{ pl: 2 }}>
            <li>Our admin team will review your application</li>
            <li>You'll receive an email with the decision</li>
            <li>
              If approved, you can access your vendor dashboard to manage your
              booth
            </li>
            <li>
              If denied, you'll receive detailed feedback and can reapply if
              eligible
            </li>
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <StyledButton onClick={handleViewDashboard}>
            View Vendor Dashboard
          </StyledButton>
        </Box>
      </Stack>
    </Paper>
  );
};

export default PendingApproval; 